module.exports = __webpack_public_path__ + "static/media/partitions_material_60yd_n.8bf08107.csv";